import { RegionalReward } from "components/atoms/RewardCard";
import { YuLifeLocale } from "hooks";

const sortById = (a, b) => {
  if (a._id < b._id) {
    return -1;
  }

  if (a._id > b._id) {
    return 1;
  }

  return 0;
};

export const getFallbackRewards = (locale: YuLifeLocale | string) => {
  switch (locale) {
    case "uk":
      return FALLBACK_REWARDS_UK.sort(sortById);
    case "us":
      return FALLBACK_REWARDS_US.sort(sortById);
    case "za":
      return FALLBACK_REWARDS_ZA.sort(sortById);
    case "jp":
      return [];
  }
};

export const FALLBACK_REWARDS_UK: RegionalReward[] = [
  {
    _id: "Adidas",
    image: "/rewards/uk/Adidas.png",
    imageAlt: "Adidas",
    heading: "Adidas",
    description: "Redeem gift vouchers on street style looks, sportswear and accessories.",
  },
  {
    _id: "Amazon",
    image: "/rewards/uk/Amazon.png",
    imageAlt: "Amazon",
    heading: "Amazon",
    description: "Redeem gift vouchers on books, electronics, Prime, Music and Video.",
  },
  {
    _id: "Big Blue Ocean Cleanup",
    image: "/rewards/uk/Big Blue Ocean Cleanup.png",
    imageAlt: "Big Blue Ocean Cleanup",
    heading: "Big Blue Ocean Cleanup",
    description: "Help bring our oceans back to life by removing plastic.",
  },
  {
    _id: "charity: water",
    image: "/rewards/uk/Charity Water.png",
    imageAlt: "charity: water",
    heading: "charity: water",
    description: "Donate to help provide families with clean and safe drinking water.",
  },
  {
    _id: "Decathlon",
    image: "/rewards/uk/Decathlon.png",
    imageAlt: "Decathlon",
    heading: "Decathlon",
    description: "Redeem gift vouchers on sports shoes, gear and equipment.",
  },
  {
    _id: "Earthly",
    image: "/rewards/uk/Earthly.png",
    imageAlt: "Earthly",
    heading: "Earthly",
    description: "Support the planet by donating and planting trees with Earthly.",
  },
  {
    _id: "Fiit",
    image: "/rewards/uk/Fiit.png",
    imageAlt: "Fiit",
    heading: "Fiit",
    description:
      "Free trial and 25% off the #1 fitness app. Get unlimited access to 500+ on demand and group workouts.",
  },
  {
    _id: "Fitbit",
    image: "/rewards/uk/Fitbit.png",
    imageAlt: "Fitbit",
    heading: "Fitbit",
    description: "Exclusive 22% discount on all fitness trackers and smart watches.",
  },
  {
    _id: "Garmin",
    image: "/rewards/uk/Garmin.png",
    imageAlt: "Garmin",
    heading: "Garmin",
    description:
      "Save up to 40% discount on selected wearables tracking steps, calories and sleep.",
  },
  {
    _id: "Nike",
    image: "/rewards/uk/Nike.png",
    imageAlt: "Nike",
    heading: "Nike",
    description: "Redeem gift vouchers on shoes and sporting clothing.",
  },
  {
    _id: "Withings",
    image: "/rewards/uk/Withings.png",
    imageAlt: "Withings",
    heading: "Withings",
    description: "Get 25% off a wide range of smart devices and health monitors.",
  },
  {
    _id: "Aldi",
    image: "/rewards/uk/Aldi.png",
    imageAlt: "Aldi",
    heading: "Aldi",
    description: "Redeem gift vouchers on groceries, fresh flowers, specialbuys and more.",
  },
  {
    _id: "Apple App Store",
    image: "/rewards/uk/App Store.png",
    imageAlt: "Apple App Store",
    heading: "Apple App Store",
    description: "Redeem gift vouchers on Apple Music, Apple TV+ and Apple Books.",
  },
  {
    _id: "Argos",
    image: "/rewards/uk/Argos.png",
    imageAlt: "Argos",
    heading: "Argos",
    description: "Redeem gift vouchers on technology, home and family products.",
  },
  {
    _id: "ASOS",
    image: "/rewards/uk/Asos.png",
    imageAlt: "ASOS",
    heading: "ASOS",
    description: "Redeem gift vouchers on the latest fashion trends in clothing and accessories.",
  },
  {
    _id: "Bloom & Wild",
    image: "/rewards/uk/Bloom & Wild.png",
    imageAlt: "Bloom & Wild",
    heading: "Bloom & Wild",
    description: "15% discount on all fresh flowers and bouquets.",
  },
  {
    _id: "Borrow My Doggy",
    image: "/rewards/uk/Borrow my doggy.png",
    imageAlt: "Borrow My Doggy",
    heading: "Borrow My Doggy",
    description: "Redeem a year’s premium membership to share your walks with a furry friend.",
  },
  {
    _id: "Google Play",
    image: "/rewards/uk/Google Play.png",
    imageAlt: "Google Play",
    heading: "Google Play",
    description: "Redeem gift vouchers on apps, games, books and movies.",
  },
  {
    _id: "Halfords",
    image: "/rewards/uk/Halfords.png",
    imageAlt: "Halfords",
    heading: "Halfords",
    description:
      "The UK's leading retailer of motoring, cycling and leisure products and services.",
  },
  {
    _id: "Hussle",
    image: "/rewards/uk/Hussle.png",
    imageAlt: "Hussle",
    heading: "Hussle",
    description:
      "1/3 off membership, giving you access to 100s of the UK’s best gyms, plus online classes from Fiit.",
  },
  {
    _id: "John Lewis",
    image: "/rewards/uk/JLP.png",
    imageAlt: "John Lewis",
    heading: "John Lewis",
    description: "Redeem gift vouchers on homeware, furniture, fashion and electricals.",
  },
  {
    _id: "Marks & Spencer",
    image: "/rewards/uk/M&S.png",
    imageAlt: "Marks & Spencer",
    heading: "Marks & Spencer",
    description: "Redeem gift vouchers on food, flowers, clothing and gifts.",
  },
  {
    _id: "Moneyhub",
    image: "/rewards/uk//Moneyhub.png",
    imageAlt: "Moneyhub",
    heading: "Moneyhub",
    description: "Free access for 6 months to the money management app.",
  },
  {
    _id: "MoveGB",
    image: "/rewards/uk/MoveGB.png",
    imageAlt: "MoveGB",
    heading: "MoveGB",
    description: "Stay active with free fitness for 3 months.",
  },
  {
    _id: "National Book Tokens",
    image: "/rewards/uk/National Book Tokens.png",
    imageAlt: "National Book Tokens",
    heading: "National Book Tokens",
    description: "Redeem gift vouchers on all your favourite books.",
  },
  {
    _id: "Ocushield",
    image: "/rewards/uk/Ocushield.png",
    imageAlt: "Ocushield",
    heading: "Ocushield",
    description: "30% discount across Ocushield's medically rated screen filters and glasses.",
  },
  {
    _id: "ODEON",
    image: "/rewards/uk/Odeon.png",
    imageAlt: "ODEON",
    heading: "ODEON",
    description: "Redeem gift vouchers on cinema tickets.",
  },
  {
    _id: "Sainsburys",
    image: "/rewards/uk/Sainsburys.png",
    imageAlt: "Sainsbury's",
    heading: "Sainsbury's",
    description: "Redeem gift vouchers on groceries, clothing, homeware and electricals.",
  },
  {
    _id: "Tesco",
    image: "/rewards/uk/Tesco.png",
    imageAlt: "Tesco",
    heading: "Tesco",
    description: "Redeem gift vouchers on groceries.",
  },
  {
    _id: "Thriva",
    image: "/rewards/uk/Thriva.png",
    imageAlt: "Thriva",
    heading: "Thriva",
    description:
      "30% off your first test. Track and improve your health with smart blood tests to take at home.",
  },
  {
    _id: "Virgin Experience Days",
    image: "/rewards/uk/Virgin.png",
    imageAlt: "Virgin Experience Days",
    heading: "Virgin Experience Days",
    description:
      "Save 20% on thousands of experiences from cooking masterclasses, to spa days and flying lessons.",
  },
  {
    _id: "Farewill",
    image: "/rewards/uk/Farewill.png",
    imageAlt: "Farewill",
    heading: "Farewill",
    description: "Secure yourself financially by writing your will for free (worth £90!)",
  },
].sort(sortById);

export const FALLBACK_REWARDS_US: RegionalReward[] = [
  {
    _id: "Amazon",
    image: "/rewards/us/Amazon.png",
    imageAlt: "Amazon",
    heading: "Amazon",
    description: "Redeem gift vouchers on books, electronics, Prime, Music and Video.",
  },
  {
    _id: "Fiit",
    image: "/rewards/us/Fiit.png",
    imageAlt: "Fiit",
    heading: "Fiit",
    description:
      "Free trial and 25% off the #1 fitness app. Get unlimited access to 500+ on demand and group workouts.",
  },
  {
    _id: "Garmin",
    image: "/rewards/us/Garmin.png",
    imageAlt: "Garmin",
    heading: "Garmin",
    description:
      "Save up to 20% discount on selected wearables tracking steps, calories and sleep.",
  },
  {
    _id: "Withings",
    image: "/rewards/us/Withings.png",
    imageAlt: "Withings",
    heading: "Withings",
    description: "Get 25% off a wide range of smart devices and health monitors.",
  },
  {
    _id: "Athleta",
    image: "/rewards/us/Athleta.png",
    imageAlt: "Athleta",
    heading: "Athleta",
    description: "Redeem gift vouchers on premium women’s activewear.",
  },
  {
    _id: "Bass Pro Shops",
    image: "/rewards/us/BassProShops.png",
    imageAlt: "Bass Pro Shops",
    heading: "Bass Pro Shops",
    description: "Redeem gift vouchers on a wide range of outdoor recreation goods.",
  },
  {
    _id: "Bath & Body Works",
    image: "/rewards/us/BathandBodyworks.png",
    imageAlt: "Bath & Body Works",
    heading: "Bath & Body Works",
    description: "Redeem gift vouchers on all your favorite body care products.",
  },
  {
    _id: "Dick's Sporting Goods",
    image: "/rewards/us/DicksSportingGoods.png",
    imageAlt: "Dick's Sporting Goods",
    heading: "Dick's Sporting Goods",
    description: "Redeem gift vouchers on sports gear, equipment, apparel and footwear.",
  },
  {
    _id: "Gamestop",
    image: "/rewards/us/Gamestop.png",
    imageAlt: "Gamestop",
    heading: "Gamestop",
    description: "Redeem gift vouchers on all of your gaming essentials.",
  },
  {
    _id: "Home Depot",
    image: "/rewards/us/HomeDepot.png",
    imageAlt: "Home Depot",
    heading: "Home Depot",
    description: "Redeem gift vouchers on all your home improvement needs.",
  },
  {
    _id: "Kohls",
    image: "/rewards/us/Khols.png",
    imageAlt: "Kohls",
    heading: "Kohls",
    description: "Redeem gift vouchers on clothing, shoes, home, kitchen and so much more!",
  },
  {
    _id: "Lowes",
    image: "/rewards/us/Lowes.png",
    imageAlt: "Lowes",
    heading: "Lowes",
    description: "Redeem gift vouchers on everything you need to improve your home.     ",
  },
  {
    _id: "Nordstrom Rack",
    image: "/rewards/us/NordstromRack.png",
    imageAlt: "AmazonNordstrom Rack",
    heading: "AmazonNordstrom Rack",
    description: "Redeem gift vouchers on clothes, shoes, jewelry and more.",
  },
  {
    _id: "Old Navy",
    image: "/rewards/us/OldNavy.png",
    imageAlt: "Old Navy",
    heading: "Old Navy",
    description: "Redeem gift vouchers on all your favorite fashion items at great prices.",
  },
  {
    _id: "Overstock",
    image: "/rewards/us/Overstock.png",
    imageAlt: "Overstock",
    heading: "Overstock",
    description: "Redeem gift vouchers on designer brands and home goods.",
  },
  {
    _id: "Roblox",
    image: "/rewards/us/Roblox.png",
    imageAlt: "Roblox",
    heading: "Roblox",
    description: "Redeem gift vouchers on all things Roblox.",
  },
  {
    _id: "Sephora",
    image: "/rewards/us/Sephora.png",
    imageAlt: "Sephora",
    heading: "Sephora",
    description: "Redeem gift vouchers on skincare, fragrance, hair and beauty products.",
  },
  {
    _id: "Target",
    image: "/rewards/us/Target.png",
    imageAlt: "Target",
    heading: "Target",
    description: "Redeem gift vouchers on groceries, clothing, electronics and much more! ",
  },
  {
    _id: "Ulta",
    image: "/rewards/us/Ulta.png",
    imageAlt: "Ulta",
    heading: "Ulta",
    description: "Redeem gift vouchers on all your favorite beauty products.",
  },
  {
    _id: "Walmart",
    image: "/rewards/us/Walmart.png",
    imageAlt: "Walmart",
    heading: "Walmart",
    description: "Redeem gift vouchers on top electronics, toys, home essentials and more!",
  },
  {
    _id: "Wayfair",
    image: "/rewards/us/Wayfair.png",
    imageAlt: "Wayfair",
    heading: "Wayfair",
    description: "Redeem gift vouchers on furniture and decor.",
  },
  {
    _id: "Zappos",
    image: "/rewards/us/Zappos.png",
    imageAlt: "Zappos",
    heading: "Zappos",
    description: "Redeem gift vouchers on shoes, sneakers, boots, accessories and clothing.",
  },
  {
    _id: "1-800 Flowers",
    image: "/rewards/us/1-800-flowers.png",
    imageAlt: "1-800 Flowers",
    heading: "1-800 Flowers",
    description: "Redeem gift vouchers on fresh flowers and gifts for every occasion.",
  },
].sort(sortById);

export const FALLBACK_REWARDS_ZA: RegionalReward[] = [
  {
    _id: "Checkers",
    image: "/rewards/za/Checkers.png",
    imageAlt: "Checkers",
    heading: "Checkers",
    description: "Redeem gift vouchers on a wide range of groceries and homeware.",
  },
  {
    _id: "Dischem",
    image: "/rewards/za/Dischem.png",
    imageAlt: "Dischem",
    heading: "Dischem",
    description: "Redeem gift vouchers on health products, toiletries and more.",
  },
  {
    _id: "Dischem Baby",
    image: "/rewards/za/DischemBaby.png",
    imageAlt: "DischemBaby",
    heading: "Dischem Baby",
    description: "Redeem gift vouchers on baby products and essentials.",
  },
  {
    _id: "Cape Union Mart",
    image: "/rewards/za/CapeUnionMart.png",
    imageAlt: "Cape Union Mart",
    heading: "Cape Union Mart",
    description: "Redeem gift vouchers on a wide range of clothing and adventure gear.",
  },
  {
    _id: "Old Khaki",
    image: "/rewards/za/OldKhaki.png",
    imageAlt: "Old Khaki",
    heading: "Old Khaki",
    description: "Redeem gift vouchers on trendy fashion for men and women.",
  },
  {
    _id: "Poetry",
    image: "/rewards/za/Poetry.png",
    imageAlt: "Poetry",
    heading: "Poetry",
    description: "Redeem gift vouchers on stylish womenswear at Poetry.",
  },
  {
    _id: "Keedo",
    image: "/rewards/za/Keedo.png",
    imageAlt: "Keedo",
    heading: "Keedo",
    description: "Redeem gift vouchers on the latest looks for your little one.",
  },
  {
    _id: "Data through Blue Label",
    image: "/rewards/za/BlueLabelData.png",
    imageAlt: "Data through Blue Label",
    heading: "Data through Blue Label",
    description: "Redeem gift vouchers for data and airtime.",
  },
  {
    _id: "Footgear",
    image: "/rewards/za/Footgear.png",
    imageAlt: "Footgear",
    heading: "Footgear",
    description: "Redeem gift vouchers for the latest sneakers and accessories.",
  },
  {
    _id: "StyleMode",
    image: "/rewards/za/Stylemode.png",
    imageAlt: "StyleMode",
    heading: "StyleMode",
    description: "Redeem gift vouchers to shop the latest looks online.",
  },
  {
    _id: "Netflorist",
    image: "/rewards/za/NetFlorist.png",
    imageAlt: "Netflorist",
    heading: "Netflorist",
    description: "Redeem gift vouchers to share flowers and gifts with your loved ones.",
  },
  {
    _id: "Mugg n Bean",
    image: "/rewards/za/MuggnBean.png",
    imageAlt: "Mugg n Bean",
    heading: "Mugg n Bean",
    description: "Redeem gift vouchers on a wide range of delicious coffee and meals.",
  },
  {
    _id: "Engen",
    image: "/rewards/za/Engen.png",
    imageAlt: "Engen",
    heading: "Engen",
    description: "Redeem gift vouchers for fuel and more, from Engen.",
  },
  {
    _id: "Garmin",
    image: "/rewards/za/Garmin.png",
    imageAlt: "Garmin",
    heading: "Garmin",
    description: "Redeem gift vouchers on the latest smart watches and other tech.",
  },
  {
    _id: "Loot",
    image: "/rewards/za/Loot.png",
    imageAlt: "Loot",
    heading: "Loot",
    description: "Redeem gift vouchers to shop at one of SA’s favourite online stores!",
  },
  {
    _id: "Food Forward SA",
    image: "/rewards/za/FoodForward.png",
    imageAlt: "Food Forward SA",
    heading: "Food Forward SA",
    description: "Donate your YuCoin to feed a person for a whole month",
  },
].sort(sortById);
